import React, { useEffect, useState, useRef } from 'react';

const ProfileHeader = ({ 
  user, 
  isEditingProfile, 
  setIsEditingProfile, 
  profileFileInputRef, 
  handleProfileImageChange,
  triggerProfileFileInput 
}) => {
  const [dominantColor, setDominantColor] = useState('108, 92, 231'); // Default accent color
  const imageRef = useRef(null);

  // Extract dominant color from image when it loads
  useEffect(() => {
    if (user?.profilePicture) {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      
      // Handle CORS issues gracefully
      img.onerror = () => {
        console.log("Error loading image for color extraction - possibly a CORS issue");
      };
      
      img.onload = () => {
        try {
          const dominantColor = extractDominantColor(img);
          setDominantColor(dominantColor);
        } catch (error) {
          console.error("Error extracting color:", error);
        }
      };
      
      // Set source after adding event handlers
      img.src = user.profilePicture;
    }
  }, [user?.profilePicture]);

  // Function to extract dominant color from image
  const extractDominantColor = (img) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    // Use a small canvas for better performance
    canvas.width = 50;
    canvas.height = 50;
    
    // Draw image on canvas
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    
    // Get image data
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    
    // Calculate average color (simple method)
    let r = 0, g = 0, b = 0;
    let pixelCount = 0;
    
    // Sample pixels (step of 4 because RGBA)
    for (let i = 0; i < imageData.length; i += 16) {
      // Skip transparent pixels
      if (imageData[i + 3] > 128) {
        r += imageData[i];
        g += imageData[i + 1];
        b += imageData[i + 2];
        pixelCount++;
      }
    }
    
    // Calculate average
    if (pixelCount > 0) {
      r = Math.floor(r / pixelCount);
      g = Math.floor(g / pixelCount);
      b = Math.floor(b / pixelCount);
      
      // Make the color more vibrant
      const enhanceFactor = 1.2;
      r = Math.min(255, Math.floor(r * enhanceFactor));
      g = Math.min(255, Math.floor(g * enhanceFactor));
      b = Math.min(255, Math.floor(b * enhanceFactor));
      
      return `${r}, ${g}, ${b}`;
    }
    
    return '108, 92, 231'; // Default if extraction fails
  };

  return (
    <div className="sidebar-header">
      <div 
        className="profile-photo"
        style={{
          '--profile-glow-color': dominantColor // CSS variable for dynamic color
        }}
        ref={imageRef}
      >
        <img src={user.profilePicture} alt={user.username} />
        {isEditingProfile && (
          <button 
            className="change-profile-photo-btn"
            onClick={triggerProfileFileInput}
          >
            Change Photo
          </button>
        )}
      </div>
      <div className="profile-username">
        <h1>{user.username}</h1>
      </div>
      
      {/* Hidden file input for profile photo */}
      <input 
        type="file" 
        onChange={handleProfileImageChange} 
        accept="image/*"
        ref={profileFileInputRef}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default ProfileHeader;